<template>
    <v-layout row wrap class="mt-5 mb-5">
        <v-flex v-for="(document, i) in content" :key="i" xs12
                sm6 lg6
                :class="{'xl4': content.length>2}"
        >
            <document :icon="document.icon" :ext="document.ext" :file_size="document.size"
                      :link="document.link"
            >{{ document.title }}</document>
        </v-flex>
    </v-layout>
</template>

<script>
import document from '@/components/blocks/documents/document.vue';
import {mapGetters} from 'vuex';

export default {
  components: {
    document,
  },
  props: {
    content: {
      type: Array,
    },
  },
};
</script>

